import PaymentMethodFragment from '../payment/PaymentMethodFragment';
import { PlanFragment } from '../plan';
export default `
	fragment SubscriptionFragment on Subscription {
		id
		description
		term
		plans {
			...PlanFragment
		}
		paymentMethod {
			...PaymentMethodFragment
		}
		startDate
		price
		discountAmount
		user {
			id
		}
		status
		meta {
			order {
				id
				billingAddress
				billingContact {
					name
					email
					phone
				}
				subtotal
				total
			}
			subscriptionReference {
				id
				defaultSettings
        endBehavior
        livemode
        metadata
        status
        subscription
        phases
        created
			}			
			subscriptionStartDate
			firstDeliveryDate
			billingCycleStartDate
		}
		createdAt
		updatedAt
	}
	${PaymentMethodFragment}
  ${PlanFragment}
`;
